import Box from '@totallymoney/ui/components/Box'
import theme from '@totallymoney/ui/theme'
import styled from 'styled-components'

import { StyledLoansTableItemProductDetail } from '../LoansTableItemProductDetail/LoansTableItemProductDetail.styled'

export const StyledLoansTableMarketingOfferContentBase = styled(Box)`
    ${StyledLoansTableItemProductDetail} + ${StyledLoansTableItemProductDetail} {
        padding-top: ${theme.space10};
        border-top: 1px solid ${theme.greyLighter};
    }

    ${theme.mediaMediumPlus`
        ${StyledLoansTableItemProductDetail} + ${StyledLoansTableItemProductDetail} {
            padding: 0 0 0 ${theme.space20};

            border-left: 1px solid ${theme.greyLighter};
            border-top: 0;
        }

        ${StyledLoansTableItemProductDetail}:nth-child(5n) {
            border-left: 0 !important;
            padding-left: 0;
        }
    `}

    ${theme.mediaLargePlus`
        ${StyledLoansTableItemProductDetail} + ${StyledLoansTableItemProductDetail} {
            border-left: 1px solid ${theme.greyLighter} !important;
            padding-left: ${theme.space20} !important;
        }
    `}
`

export const StyledLoanTableContentBase = styled(Box)`
    gap: ${theme.space10};

    ${StyledLoansTableItemProductDetail} + ${StyledLoansTableItemProductDetail} {
        padding-top: ${theme.space10};

        border-top: 1px solid ${theme.greyLighter};
    }

    ${theme.mediaMediumPlus`
        gap: ${theme.space20};

        ${StyledLoansTableItemProductDetail} + ${StyledLoansTableItemProductDetail} {
            padding: 0 0 0 ${theme.space20};

            border-left: 1px solid ${theme.greyLighter};
            border-top: 0;
        }
    `}
`
